<!--/* eslint-disable */-->
<template>
  <div>
    <div v-if="serasaServiceType === 'MANUAL'" class="flex gap-4 items-center">

      <div>
        <vs-button
          class="bg-primary"
          :disabled="companyGuid == null"
          @click="validate">Cadastrar</vs-button>
      </div>

      <div>
        <date-picker
          v-model="scoreForm.date"
          name="data"
          v-validate="'required'"
          :append-to-body="false"
          class="w-full z-index-bg"
          :disabled-date="disabledAfterToday"/>
      </div>

      <div>
        <vs-checkbox
          v-model="nullScore"
        >
          Sem Nota
        </vs-checkbox>
      </div>

      <div>
        <label>Nota</label>
        <NumericInput
          v-model="scoreForm.value"
          minimum-fraction-digits="0"
          :disable="nullScore"
          class="mb-4"
        />
      </div>

      <div>
        <vs-checkbox
          v-model="convertSerasa"
          :disabled="nullScore"
        >
          Converter Credit Rating em Serasa
        </vs-checkbox>
      </div>

    </div>

    <div v-if="serasaServiceType === 'AUTOMATIC'" class="flex gap-4 items-center">
      <vs-button
          class="bg-primary"
          :disabled="companyGuid == null"
          @click="createSerasaApiScore">Cadastrar novo score</vs-button>
    </div>

    <div>
      <vs-table
        class="mt-4"
        v-model="selected"
        stripe
        @selected="handleSelected"
        :data="scores"
        noDataText="Não há valores cadastrados para esta empresa.">
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th>
            Data
          </vs-th>
          <vs-th>
            Nota
          </vs-th>
          <vs-th>
            Apagar
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr]">
              <vs-checkbox
                v-model="data[indextr].checked"
                disabled="true"
              />
            </vs-td>

            <vs-td :data="data[indextr]">
              {{ data[indextr].date | formatDate }}
            </vs-td>

            <vs-td :data="data[indextr]">
              <span v-if="data[indextr].value != null">{{ data[indextr].value }}</span>
              <span v-else>Sem nota</span>
            </vs-td>

            <vs-td :data="data[indextr]">
              <span role="button" style="cursor: pointer; color: blue" @click="deleteScore(tr)">Apagar Nota</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </div>
  </div>

</template>

<script>
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import moment from 'moment'
import NumericInput from './NumericInput'

export default {
  name: 'SerasaForm',
  props: {
    companyGuid: String,
  },
  watch: {
    nullScore() {
      if (this.nullScore === true) {
        this.scoreForm.value = null
        this.convertSerasa = false
      }
    },

    companyGuid() {
      this.getValues()
    }
  },
  components: {
    DatePicker,
    moment,
    NumericInput
  },
  data () {
    return {
      serasaServiceType: 'MANUAL',
      nullScore: false,
      checkBoxArray: [],
      convertSerasa: false,
      selected: null,
      scoreForm: {
        companyGuid: null,
        date: null,
        value: null
      },
      scores: [],
      complianceValues: [],
      sectorAnalysisValues: []
    }
  },
  beforeMount() {
    this.serasaService()
  },
  methods: {
    serasaService() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/tenant/role`, {
        params: {
          role: 'SCORE'
        }
      })
      .then((response) => {
        this.serasaServiceType = response.data.type
      })
    },

    createSerasaApiScore() {
      if (this.companyGuid == null) return

      this.scoreForm.companyGuid = this.companyGuid
      axios.get(`${process.env.VUE_APP_API}/api/v1/serasa-api/${this.companyGuid}`)
        .then(() => {
          this.getValues()
        })
    },

    disabledAfterToday (date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },

    getValues () {
      if (this.companyGuid == null) return

      this.scoreForm.companyGuid = this.companyGuid
      axios.get(`${process.env.VUE_APP_API}/api/v1/serasa/${this.companyGuid}`)
        .then((response) => {
          this.scores = response.data
          for (let i = 0; i < this.scores.length; i++) {
            this.scores[i].checked = false
          }
        })
    },

    getSelected() {
      return this.selected
    },

    convertScore(value) {

      switch (value) {
        case 1:
          return 951
        case 2:
          return 901
        case 3:
          return 851
        case 4:
          return 801
        case 5:
          return 751
        case 6:
          return 701
        case 7:
          return 651
        case 8:
          return 601
        case 9:
          return 551
        case 10:
          return 501
        case 11:
          return 451
        case 12:
          return 401
        case 13:
          return 351
        case 14:
          return 301
        case 15:
          return 251
        case 16:
          return 201
        case 17:
          return 151
        case 18:
          return 101
        case 19:
          return 51
        case 20:
          return 3
        case 21:
          return 2
        case 22:
          return 1
        case 23:
          return 0
        default:
          return null
      }

    },

    validate () {
      if (this.convertSerasa) {
        this.scoreForm.value = this.convertScore(this.scoreForm.value)
        if (this.scoreForm.value == null) {
          this.$vs.notify({
            color: 'danger',
            text: 'Nota inválida. Escolha um valor entre 1 e 23'
          })
          return
        }
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.setValue()
        } else {
          for (const idx in this.errors.items) {
            this.$vs.notify({
              color: 'danger',
              text: this.errors.items[idx].msg
            })
          }
        }
      })
    },

    setValue () {
      if (this.companyGuid == null) {
        this.$vs.notify({
          color: 'danger',
          text: 'Selecione um garantidor.'
        })
        return
      }

      this.scoreForm.companyGuid = this.companyGuid

      axios.post(`${process.env.VUE_APP_API}/api/v1/serasa`, this.scoreForm)
        .then((response) => {
          this.scores = response.data
        })
        .finally(() => {
          this.getValues()
          this.scoreForm.value = null
          this.scoreForm.date = null
          this.convertSerasa = false
          this.nullScore = false
        })
    },

    deleteScore(tr) {
      axios.delete(`${process.env.VUE_APP_API}/api/v1/serasa/` + tr.guid)
        .then((response) => {
          this.scores = response.data
        })
        .finally(() => {
          this.getValues()
        })
    },

    handleSelected (tr) {
      for (let i = 0; i < this.scores.length; i++) {
        this.scores[i].checked = tr.guid === this.scores[i].guid;
      }
    },

  }
}
</script>

<style scoped>
  .z-index-bg {
    z-index: 500;
  }
</style>
